import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { RouterOutlet, RouterLink, RouterLinkActive } from '@angular/router';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTabsModule } from '@angular/material/tabs';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MsalBroadcastService, MsalService } from '@azure/msal-angular';
import { InteractionStatus, RedirectRequest } from '@azure/msal-browser';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { environment } from '@environments/environment';

@Component({
  selector: 'app-root',
  imports: [
    RouterOutlet,
    RouterLink,
    RouterLinkActive,
    MatToolbarModule,
    MatTabsModule,
    MatButtonModule,
    MatIconModule,
    MatTooltipModule,
  ],
  templateUrl: './app.html',
  styleUrl: './app.css',
})
export class App implements OnInit, OnDestroy {
  private authService = inject(MsalService);
  private broadcastService = inject(MsalBroadcastService);
  private readonly _destroying$ = new Subject<void>();

  loggedIn = false;
  userName = '';

  ngOnInit(): void {
    // Process the Azure AD redirect response (equivalent to MsalRedirectComponent)
    this.authService.handleRedirectObservable().subscribe();

    this.broadcastService.inProgress$
      .pipe(
        filter((status) => status === InteractionStatus.None),
        takeUntil(this._destroying$)
      )
      .subscribe(() => this.updateLoginState());

    this.updateLoginState();
  }

  private updateLoginState(): void {
    const accounts = this.authService.instance.getAllAccounts();
    this.loggedIn = accounts.length > 0;
    if (accounts.length > 0 && !this.authService.instance.getActiveAccount()) {
      this.authService.instance.setActiveAccount(accounts[0]);
    }
    this.userName = accounts[0]?.name ?? accounts[0]?.username ?? '';
  }

  logout(): void {
    this.authService.logoutRedirect();
  }

  switchAccount(): void {
    const request: RedirectRequest = {
      scopes: [environment.auth.apiScope],
      prompt: 'select_account',
    };

    this.authService.loginRedirect(request);
  }

  ngOnDestroy(): void {
    this._destroying$.next(undefined);
    this._destroying$.complete();
  }
}
